import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getFlagById, getFlaggedDataColumns } from "../../services/flag";
import { useDispatch } from "react-redux";
import {
  setFlagData,
  setFlaggedDataColumns,
} from "../../redux/features/flagDetails/flagDetailsSlice";

const useFlagDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    isLoading: isLoadingFlagData,
    error: errorFlagData,
  } = useQuery({
    queryKey: ["flag-details", id],
    queryFn: () => getFlagById(id),
    select: (data) => {
      if (data) {
        dispatch(setFlagData(data));
      }
    },
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  const {
    isLoading: isLoadingColumnsData,
    error: errorFetchingColumnsData,
  } = useQuery({
    queryKey: ["flagged-data-columns", id],
    queryFn: () => getFlaggedDataColumns(id),
    select: (data) => {
      if (data) {
        dispatch(setFlaggedDataColumns(data));
      }
    },
    retry: 1,
    refetchOnWindowFocus: false,
  });

  const isLoading = isLoadingFlagData || isLoadingColumnsData;

  return {
    error: errorFlagData || errorFetchingColumnsData,
    loading: isLoading,
  };
};

export default useFlagDetails;
